
import { useState, useEffect } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'María Elena',
    role: 'Escritora de ficción',
    avatar: 'https://public.readdy.ai/ai/img_res/136015554d6b041c5c75e583e3529796.jpg',
    quote: 'Raíz me ayudó a encontrar palabras que ni sabía que tenía. Después de años de bloqueo, por fin siento que escribo desde un lugar auténtico. La meditación es transformadora.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Carmen Lucía',
    role: 'Poeta y narradora',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20creative%20Latin%20woman%20in%20her%2030s%20with%20thoughtful%20expression%20soft%20lighting%20artistic%20headshot%20warm%20earthy%20tones%20writer%20aesthetic&width=100&height=100&seq=testimonial-raiz-2&orientation=squarish',
    quote: 'El mapa de ensoñación se ha convertido en mi herramienta favorita. Cada vez que hago el ritual descubro nuevas capas de mi imaginario. Es como tener un pozo infinito de inspiración.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Ana Sofía',
    role: 'Novelista',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20sophisticated%20woman%20writer%20in%20her%2050s%20with%20silver%20hair%20gentle%20smile%20soft%20natural%20lighting%20warm%20tones%20artistic%20professional%20headshot&width=100&height=100&seq=testimonial-raiz-3&orientation=squarish',
    quote: 'Llevaba meses sin poder avanzar en mi novela. Después de Raíz, no solo desbloqueé la historia, sino que encontré la voz de mi protagonista. Ahora uso el ritual para cada personaje nuevo.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Valentina',
    role: 'Escritora creativa',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20creative%20woman%20in%20her%2020s%20with%20artistic%20vibe%20soft%20lighting%20warm%20sepia%20tones%20dreamy%20expression%20writer%20aesthetic%20headshot&width=100&height=100&seq=testimonial-raiz-4&orientation=squarish',
    quote: 'No tenía experiencia en meditación y tenía mis dudas. Pero la guía de voz es tan cálida y accesible que me sentí acompañada desde el primer momento. Ahora es mi ritual semanal.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Isabel',
    role: 'Guionista',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20woman%20in%20her%2040s%20with%20dark%20hair%20warm%20smile%20professional%20creative%20look%20soft%20lighting%20warm%20earthy%20tones%20artistic%20headshot&width=100&height=100&seq=testimonial-raiz-5&orientation=squarish',
    quote: 'El cuaderno creativo es oro puro. Los ejercicios de campo semántico me ayudaron a definir mi estilo de una forma que ningún curso de escritura había logrado. Totalmente recomendado.',
    rating: 5,
  },
];

export default function TestimonialsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <div className="relative">
      {/* Main Carousel */}
      <div className="relative overflow-hidden">
        <div 
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="w-full flex-shrink-0 px-4"
            >
              <div className="max-w-3xl mx-auto">
                <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg border border-gray-100">
                  {/* Quote Icon */}
                  <div className="flex justify-center mb-6">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#D6D57B]/20 to-[#D6D57B]/5 rounded-full">
                      <i className="ri-double-quotes-l text-[#D6D57B] text-3xl"></i>
                    </div>
                  </div>

                  {/* Quote Text */}
                  <p className="text-xl md:text-2xl text-gray-700 text-center leading-relaxed mb-8 font-serif italic">
                    "{testimonial.quote}"
                  </p>

                  {/* Rating */}
                  <div className="flex justify-center gap-1 mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#D6D57B] text-xl"></i>
                    ))}
                  </div>

                  {/* Author */}
                  <div className="flex items-center justify-center gap-4">
                    <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-[#D6D57B]/30">
                      <img 
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="text-left">
                      <p className="font-semibold text-gray-900">{testimonial.name}</p>
                      <p className="text-sm text-gray-500">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={goToPrev}
        className="absolute left-0 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg border border-gray-100 text-gray-600 hover:text-[#D6D57B] hover:border-[#D6D57B]/30 transition-all cursor-pointer z-10"
        aria-label="Anterior"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        onClick={goToNext}
        className="absolute right-0 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg border border-gray-100 text-gray-600 hover:text-[#D6D57B] hover:border-[#D6D57B]/30 transition-all cursor-pointer z-10"
        aria-label="Siguiente"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-8">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentIndex 
                ? 'bg-[#D6D57B] w-8' 
                : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Ir a testimonio ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
